import MainNavBar2 from "../../components/Main_Interface/MainNavBar/MainNavBar2";
import MainCarousel from "../../components/Main_Interface/MainCarousel/MainCarousel";
import MainCarousel2 from "../../components/Main_Interface/MainCarousel/MainCarousel2";
//import MainFeature from "../../components/Main_Interface/Cards/MainFeature";
import MainFeature2 from "../../components/Main_Interface/Cards/MainFeature2";
import MainFooter from "../../components/Main_Interface/Footer/Footer";
import MainCategory from "../../components/Main_Interface/Category/MainCategory";
import MainCategoryHouseType from "../../components/Main_Interface/Category/MainCategoryHouseType";
import MainReview from "../../components/Main_Interface/Review/MainReview";
import MainReview2 from "../../components/Main_Interface/Review/MainReview2";
import MainFloatingButton from "../../components/Main_Interface/Footer/MainFloatingButton";
import Loader from "../../components/CMS/Loader/Loader";

import {useState, useEffect} from 'react'
import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default function HomePage() {
    const [featuredProjects, setFeaturedProjects] = useState([]);
    const [carouselImgs, setCarouselImgs] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [featuredLoading, setFeaturedLoading] = useState(true);
    const [carouselLoading, setCarouselLoading] = useState(true);
    const [reviewsLoading, setReviewsLoading] = useState(true);

    useEffect(() => {
        getCarouselImgs();
        getFeaturedProjects();
        getReviews();

        localStorage.setItem("form_project_detail", false)
        localStorage.removeItem("pageCount");
        localStorage.removeItem("pageValue");
        localStorage.removeItem("offset");
        localStorage.removeItem("ItemOffset");
        localStorage.removeItem("projectBuildingStyle");
        localStorage.removeItem("projectBuildingType");
        localStorage.removeItem("hasFeatured") ;
        localStorage.removeItem("projectHouseName");
    }, []);

    function getCarouselImgs() {
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/banners';
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                setCarouselImgs(usefulData.data)
                setCarouselLoading(false);
            })
            .catch((e) => {
                console.error(`An error occurred: ${e}`)
            });
    }

    function getFeaturedProjects(){
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/featuredProject';
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                let newArray = usefulData.data.slice(0,12);
                setFeaturedProjects(newArray);
                setFeaturedLoading(false);
            })
            .catch((e) => {
                console.error(`An error occurred: ${e}`)
            });
    }

    function getReviews(){
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/comments';
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                const getReviewData = []
                for(let i=0; i<usefulData.data.length; i++){
                    getReviewData.push(JSON.parse(usefulData.data[i]));
                }
                setReviews(getReviewData);
                setReviewsLoading(false);
            })
            .catch((e) => {
                console.error(`An error occurred: ${e}`)
            });
    }

    return (
        <>
            <MainNavBar2 currentPage={"home"}></MainNavBar2>
            {
                (carouselLoading === true)
                    ? <Loader></Loader>
                    : <>
                        <MainCarousel2 carouselImgs={carouselImgs}></MainCarousel2>       
                    </>
            }
            {/* <AnimationOnScroll animateIn="animate__backInUp" animateOnce={true}>
            </AnimationOnScroll> */}
            <MainCategoryHouseType></MainCategoryHouseType>
            {
                (featuredLoading === true)
                ?<Loader></Loader>
                :<>
                    {/* <AnimationOnScroll animateIn="animate__backInRight" animateOnce={true}>
                    </AnimationOnScroll> */}
                    <MainFeature2 featuredProjects = {featuredProjects}></MainFeature2>
                </>
            }
            <MainCategory></MainCategory>
            {
                (reviewsLoading === true)
                ?<Loader></Loader>
                :<>
                    {/* <AnimationOnScroll animateIn="animate__bounceIn" animateOnce={true}>
                    </AnimationOnScroll> */}
                    <MainReview2 reviews={reviews}></MainReview2>
                </>
            }
            <MainFloatingButton></MainFloatingButton>
            <MainFooter></MainFooter>
        </>
    );
}